import Swiper from 'swiper';


export default class {

  constructor() {
    this.swiper = null;

    this.init();
  }

  init() {
    this.swiper = new Swiper ('.swiper-container', {
      direction: 'horizontal',
      clickable: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/SwiperController.js